import { ColumnDef } from "@tanstack/react-table";
import { DATE_FORMATS, MODIFIED_BY_OI_TEXT } from "constants/configs";
import { IApplicationHistoryEntity } from "models/Application.model";
import React from "react";
import { useTranslation } from "react-i18next";
import { formatDateStr } from "utils/formatDateStr";
import ParticipantHistoryTableDetailsCell from "../ParticipantHistoryTableDetailsCell";
import IntelligenceTag from "components/IntelligenceTag/IntelligenceTag";

export const useParticipantHistoryColumns = () => {
  const { t } = useTranslation();

  const participantHistoryColumns: ColumnDef<IApplicationHistoryEntity, any>[] = React.useMemo(
    () => [
      {
        accessorKey: "timestamp",
        header: t("Date"),
        size: 195,
        accessorFn: (originalRow) => formatDateStr(originalRow.timestamp, DATE_FORMATS.FULL_DATE_WITH_TIME),
        enableSorting: true,
        sortingFn: (rowA, rowB) => {
          const dateA = rowA.original.timestamp;
          const dateB = rowB.original.timestamp;

          if (dateA < dateB) {
            return -1;
          }
          return dateA > dateB ? 1 : 0;
        },
      },
      {
        accessorKey: "modifiedBy",
        header: t("Modified By"),
        size: 261,
        enableSorting: false,
        accessorFn: (originalRow) =>
          originalRow.modifiedBy?.startsWith(MODIFIED_BY_OI_TEXT) ? "AI" : originalRow.modifiedBy,
        cell: (props) => {
          if (props.row.original.modifiedBy?.startsWith(MODIFIED_BY_OI_TEXT)) {
            return <IntelligenceTag />;
          }

          return props.row.original.modifiedBy;
        },
      },
      {
        accessorKey: "eventData",
        header: t("Details"),
        cell: (props) => <ParticipantHistoryTableDetailsCell {...props} />,
        enableSorting: false,
      },
    ],
    [t]
  );

  return participantHistoryColumns;
};
